<template>
  <div>
    <div
      class="collapsible-panel__header flex-container align-middle"
      @click="isPanelCollapsed = !isPanelCollapsed"
    >
      <button class="collapsible-panel__button flex-container align-middle align-center">
        <span
          class="collapsible-panel__arrow round-arrow"
          :class="{ 'arrow-collapsed': isPanelCollapsed }"
        />
      </button>
      <p class="collapsible-panel__title" v-html="title" />
    </div>
    <div
      v-if="!isPanelCollapsed"
      class="collapsible-panel__content"
      data-test-basket-collapsible-panel
    >
      <slot />
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CollapsiblePanel',
  props: {
    title: {
      type: String,
      default: () => ''
    },
    expanded: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      isPanelCollapsed: !this.expanded
    };
  }
});
</script>
<style lang="scss" scoped>
@import 'src/styles/all';

.collapsible-panel__header {
  cursor: pointer;
  width: 100%;
}

.collapsible-panel__button {
  width: auto;
  height: rem-calc(30);
  background-color: $disturber-color;
  color: white;
}

.collapsible-panel__title {
  margin-left: rem-calc(8);
  margin-bottom: 0;
  text-decoration-line: underline;
  text-decoration-thickness: 1px;
}

.collapsible-panel__content {
  width: 100%;
  padding-top: rem-calc(16);
}

.collapsible-panel__arrow {
  transition: transform 0.2s;
  transform: rotate(180deg);

  &.arrow-collapsed {
    transform: rotate(0deg);
  }
}
</style>
